import { AppBar, Button, Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles'
import AlertBanner from '@src/components/Common/AlertBanner'
import { useAlertBanner } from '@src/contexts/alert-banner-context'
import type { JSX } from 'react'
import AdminMenu from './AdminMenu'
import CollectionMenu from './CollectionMenu'
import CompanySelector from './CompanySelector'
import LanguagePicker from './LanguagePicker'
import LoanMenu from './LoanMenu'
import ProfileMenu from './ProfileMenu'
import ThemeModePicker from './ThemeModePicker'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  displayPrint: 'none',
  '& .MuiButton-root': {
    color: 'inherit',
  },
  '& .MuiIconButton-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-root': {
    color: 'inherit',
  },
  '& .MuiInputBase-input': {
    color: 'inherit',
  },
  '& .MuiSelect-icon': {
    color: 'inherit',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
  '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.white,
  },
}))

const AppHeader = (): JSX.Element => {
  const { banner } = useAlertBanner()
  const hasAlertBanner = banner.message !== null

  return (
    <>
      {hasAlertBanner && <AlertBanner message={banner.message!} severity={banner.severity} />}
      <StyledAppBar
        position="sticky"
        color="secondary"
        sx={[hasAlertBanner ? { top: 48 } : { top: 0 }]}
      >
        <Toolbar>
          <Button href="/" sx={{ flexShrink: 0, mr: 2 }}>
            <img src="/images/iFinance-white.svg" alt="Iceberg Finance" style={{ width: '110px', height: '40px' }} />
          </Button>
          <span style={{ flexGrow: 1 }}>&nbsp;</span>
          <CompanySelector />
          <LoanMenu />
          <CollectionMenu />
          <AdminMenu />
          <ProfileMenu />
          <LanguagePicker />
          <ThemeModePicker />
        </Toolbar>
      </StyledAppBar>
    </>
  )
}

export default AppHeader
